import { useCallback } from 'react';

const useAddressData = ({ setFieldValue, prefix }) => {
  return useCallback(
    result => {
      const { country, town, address01, address02 } = result;
      if (country) setFieldValue(`${prefix}country`, country);
      if (town) setFieldValue(`${prefix}town`, town);
      if (address01) setFieldValue(`${prefix}address01`, address01);
      if (address02) setFieldValue(`${prefix}address02`, address02);
    },
    [setFieldValue, prefix]
  );
};

export default useAddressData;
